var map = {
	"./bee.svg": "b809",
	"./black-hexagon-mesh.jpg": "841c",
	"./bride-1.jpg": "a5c0",
	"./bride-2.jpg": "5384",
	"./cakes.jpeg": "8dee",
	"./crowd.jpg": "f368",
	"./fonts/pacifico-webfont.woff": "90bf",
	"./fonts/pacifico-webfont.woff2": "08eb",
	"./fonts/pacifico.ttf": "9c91",
	"./hero-video-comp.mp4": "32ba",
	"./icon-facebook.svg": "431d",
	"./icon-mail.svg": "9409",
	"./loading.gif": "cf1c",
	"./logo.png": "cf05",
	"./pic1.jpg": "ea45",
	"./pic2.jpg": "94a0",
	"./pic3.jpg": "0a1a",
	"./pic4.jpg": "d82a",
	"./pic5.jpg": "5393",
	"./pic6.jpg": "9af4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";